export default (container = document) => {
    let links = container.querySelectorAll('a[href="#cashback"]')

    links.forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault()

            $app.runEvent('cashback', link.dataset.event)

            swal.fire({
                allowEscapeKey: false,
                showCloseButton: true,
                allowOutsideClick: false,
                title: 'Получите 200 рублей!',
                showConfirmButton: link.dataset.id,
                confirmButtonColor: 'var(--cl-green)',
                html: document.getElementById('cashback').innerHTML,
                confirmButtonText: '<i class="gbi-thumbs-up"></i> Забронировать'
            }).then(result => {
                if (result.isConfirmed && link.dataset.id) {
                    let bron = document.querySelector(`a[href*="/bar/bron?id=${link.dataset.id}"]`)

                    if (link.dataset.event === 'листинг') {
                        bron = bron.cloneNode()
                        bron.href = bron.href.replace(/\?.*$/, '/nobar')
                    }

                    $.fancybox.open(bron)
                }

                $app.runEvent('cashback', { [link.dataset.event]: result.isConfirmed ? 'забронировать' : 'закрыть' })
            })
        })

        if (location.hash === '#cashback' && links[0] !== undefined) {
            links[0].dispatchEvent(new Event('click'))
        }
    })
}